// chat.* — text chat send/broadcast.
// (protocol-events.md §3)
import { z } from 'zod';
import { MAX_CHAT_TEXT_LENGTH, MIN_CHAT_TEXT_LENGTH } from '../constants.js';
// ─── client → server ────────────────────────────────────────────────────────
/**
 * `chat.send` — request to broadcast a chat message.
 *
 * ROM users are silently dropped server-side (no error response).
 * (protocol-events.md §3.2)
 */
export const chatSendSchema = z.object({
    t: z.literal('chat.send'),
    text: z.string().min(MIN_CHAT_TEXT_LENGTH).max(MAX_CHAT_TEXT_LENGTH),
});
// ─── server → client (broadcast) ────────────────────────────────────────────
/**
 * `chat.message` — broadcast of a chat line.
 *
 * `displayName` is captured at send time; subsequent rename via
 * `member.name-change` does NOT mutate already-delivered messages.
 * (protocol-events.md §3.4)
 */
export const chatMessageSchema = z.object({
    t: z.literal('chat.message'),
    uid: z.string(),
    displayName: z.string(),
    text: z.string().min(MIN_CHAT_TEXT_LENGTH).max(MAX_CHAT_TEXT_LENGTH),
    seq: z.number().int().nonnegative(),
    ts: z.number().int().nonnegative(),
});
//# sourceMappingURL=chat.js.map